import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { JsonFormsDispatch, useJsonForms } from "@jsonforms/react";
import React from "react";
import { useSelector } from "react-redux";

export const wizardProgressRendererRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("WizardProgress")
);

function WizardProgressRenderer({ uischema }: RendererProps) {
  const { renderers, cells } = useJsonForms();
  // Name of the wizard
  const name = uischema?.options?.name;
  const progressIndicator = useSelector(
    (state: any) => state.reduxState?.[name]?.progressIndicator
  );
  return progressIndicator ? (
    <JsonFormsDispatch
      renderers={renderers}
      cells={cells}
      uischema={progressIndicator}
      schema={{}}
    />
  ) : null;
}

export default WizardProgressRenderer;
